/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { isString } from '@e180/util/lib/type';

import styles from './Avatar.style';

import avatarSizes from './setting/avatarSizes';
import {
  xsmall,
  small,
  medium,
  large,
  xlarge,
  xxlarge,
} from './setting/avatarVariants';
import ResponsivePicture from '@e180/ui/lib/component/ResponsivePicture';

import type { Picture } from '@e180/domain/lib/base/type';
import type { AvatarProps } from './type/avatarTypes';

type Props = AvatarProps & { src: string | Picture };

const useStyles = createUseStyles(styles);
const variantSizeMap = {
  // $FlowIssue
  [xsmall]: 'xsmall',
  // $FlowIssue
  [small]: 'small',
  // $FlowIssue
  [medium]: 'medium',
  // $FlowIssue
  [large]: 'large',
  // $FlowIssue
  [xlarge]: 'xlarge',
  // $FlowIssue
  [xxlarge]: 'xxlarge',
};

const Avatar = ({ layoutClass, variant, alt, src }: Props): React.Node => {
  // $FlowIssue
  const sizeKey = variantSizeMap[variant];

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-xsmall']]: variant === xsmall,
    [classes['root-small']]: variant === small,
    [classes['root-medium']]: variant === medium,
    [classes['root-large']]: variant === large,
    [classes['root-xlarge']]: variant === xlarge,
    [classes['root-xxlarge']]: variant === xxlarge,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const props = {
    alt,
  };

  if (isString(src)) {
    return <img {...props} className={rootClasses} src={src} />;
  }

  return (
    <ResponsivePicture
      {...props}
      layoutClass={rootClasses}
      picture={src}
      displayWidth={avatarSizes[sizeKey]}
    ></ResponsivePicture>
  );
};

// Make variants available
export * from './setting/avatarVariants';

export default compose(React.memo)(Avatar);
